import { useLocation } from 'react-router';
import { ethers, Contract } from 'ethers';
import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import PlayerIcon from '../Utils/PlayerIcon';
import DJackGameTotalPointsText from './DJackGameTotalPointsText';

interface IProps {
  players: string[];
  totalPoints: number[];
  entryFee: string;
  contract: Contract;
}

const shorter = (str: any) =>
  str?.length > 8 ? `${str.slice(0, 5)}...${str.slice(-4)}` : str;

const DJackGameStandings: React.FC<IProps> = ({
  players,
  totalPoints,
  entryFee,
  contract
}: IProps) => {
  // context
  const { account } = useWeb3React<Web3Provider>();
  const location = useLocation();
  const path = location.pathname.split('/')[2];

  // functions
  const onJoin = async (seat: number) => {
    if (account) {
      try {
        await contract.join(path, seat, {
          value: entryFee
        });
      } catch (error: any) {
        if (error.data) {
          window.alert(error.data.message);
        } else {
          window.alert(error.message);
        }
      }
    }
  };

  return (
    <>
      {players.map((player, index) =>
        account &&
        !Object.values(players).includes(account) &&
        player === ethers.constants.AddressZero ? (
          <button
            type="button"
            key={index}
            className="djackGameStandingsJoinButton"
            onClick={() => onJoin(index)}
            disabled={!account}
          >
            +
          </button>
        ) : (
          <div className="playerWrapper" key={index}>
            <div className="playerIcon">
              <PlayerIcon active={account === player} />
            </div>
            <div
              className="playerText"
              style={{ color: account === player ? '#f8f8f8' : '#d3d3d3' }}
            >
              {player !== ethers.constants.AddressZero ? shorter(player) : '-'}
            </div>
            <DJackGameTotalPointsText
              totalPointsInput={totalPoints[index]}
              large={false}
              active={account === player}
            />
          </div>
        )
      )}
    </>
  );
};

export default DJackGameStandings;
